import React from 'react';
import PropTypes from 'prop-types';
import { singleOrArray } from 'Helpers/PropTypes';
import Tt from 'Components/Ant/Tooltip';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';

import './index.css';

const Tooltip = ({
  title, placement, children, overlayClassName, ...rest
}) => (
  <Tt title={title} placement={placement} overlayClassName={overlayClassName} {...rest}>
    {children}
  </Tt>
);

const FaTooltip = props => (
  <Tooltip {...props}>
    <FontAwesome {...props} className="tooltip-fa" />
  </Tooltip>
);

const FaTooltipWrapper = (props) => {
  const { children } = props;
  return (
    <div className="tooltip-wrapper">
      {children}
      <div className="tooltip-fa-div">
        <FaTooltip {...props} />
      </div>
    </div>
  );
};

const Placements = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom',
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight',
  leftTop: 'leftTop',
  leftBottom: 'leftBottom',
  rightTop: 'rightTop',
  rightBottom: 'rightBottom',
};

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  children: singleOrArray(PropTypes.node).isRequired,
  overlayClassName: PropTypes.string,
};

Tooltip.defaultProps = {
  placement: Placements.right,
  overlayClassName: '',
};

FaTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  children: singleOrArray(PropTypes.node).isRequired,
  icon: PropTypes.string,
};

FaTooltip.defaultProps = {
  placement: Placements.right,
  icon: 'question-circle',
};

FaTooltipWrapper.propTypes = {
  children: singleOrArray(PropTypes.node).isRequired,
};

export {
  FaTooltipWrapper, FaTooltip, Tooltip, Placements,
};
